
import NameAvatar from '@/components/NameAvatar.vue'
import { RouteName } from '@/router'
import Vue from 'vue'
import Component from 'vue-class-component'

@Component({
  components: {
    NameAvatar,
  },
})
export default class UnknownPage extends Vue {
  back(): void {
    this.$router.push({ name: RouteName.home })
  }
}
